export default {
  props: {
    task: {
      type: Object,
      default: () => ({})
    },
    color: {
      type: String,
      default: 'blue lighten-3'
    }
  },

  computed: {
    time() {
      const from = this.task.time_from || '';
      const to = this.task.time_to || '';

      return `${from} - ${to}`.trim();
    },
    status() {
      return (this.task.status && this.task.status.name) || '';
    }
  },

  methods: {
    view() {
      this.$emit('view', this.task);
    }
  }
};
